import { Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import PageContainer from 'src/components/container/PageContainer';

import { IconCurrencyRupee } from '@tabler/icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // import first
import { axiosInstance } from 'src/api/axios';
import CategoryBlock from 'src/components/shared/CategoryBlock';
import Carousel from '../dashboard/components/carousel/Carousel';

const LeadsPage = () => {
  // const [product, setProduct] = useState([]);

  // useMemo(() => {
  //   axiosInstance.get('/product').then((response) => {
  //     console.log(response.data);
  //     let filtered_products = Array.isArray(response.data)
  //       ? response.data.filter((i) => i.category.toLowerCase() === 'top')
  //       : [];
  //     // let filtered_products = response.data
  //     let imageSeperator =
  //       (filtered_products.length &&
  //         filtered_products[0].images.length &&
  //         (filtered_products[0].images[0].includes('build') ? 'build' : 'src')) ||
  //       '';
  //     filtered_products.forEach((i) =>
  //       i.images.map((i) => i.split(imageSeperator)[1].replace('\\\\', '\\')),
  //     );
  //     setProduct([...filtered_products]);
  //   });
  // }, []);
  // const [user, setUser] = useState({});
  useMemo(() => {
    axiosInstance.get('/users').then((response) => {
      if ('status' in response && response.status === 200) {
        //   if(!response.data.isEmailVerified){
        //     window.location.href = '/auth/verify'
        // }
        // if(!response.data.gender || !response.data.dob){
        //     window.location.href = '/auth/onboarding'
        // }
        // setUser(response.data)
      }
    });
  }, []);

  // const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return (
    <PageContainer
      title="Product Category | Earnpati"
      description="this is Offers Category page of Earnpati"
      sx={{ maxWidth: { xs: '100vw', lg: '70vw' }, pl: '5px' }}
    >
      <CategoryBlock
        title={
          <Typography variant="h5" sx={{ paddingLeft: '10px' }}>
            Sell and Earn{' '}
            {
              <span
                style={{
                  verticalAlign: 'middle',
                }}
              >
                <IconCurrencyRupee />
              </span>
            }
            1 Lakh Per Month
          </Typography>
        }
      />
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="h5">Newly Added Products</Typography>
        </Grid>
        <Grid item sx={{ width: '100%', mt: { sm: 0, xs: -3 } }}>
          <Carousel />
        </Grid>
      </Grid>
      <ToastContainer />
    </PageContainer>
  );
};

export default LeadsPage;
